module.exports = __webpack_public_path__ + "img/ddyfz.b384ec08.gif";